import type {ReactElement} from 'react';
import React from 'react';
import type {OrderDownloadStateNew} from '@Components/download-panel/download-panel.reducer';
import {DownloadStateTypes, setCurrentViewingOrderIdKey, setIsViewingDropboxDownloads} from '@Components/download-panel/download-panel.reducer';
import {PanelHeader} from '@Components/panel';
import {useAppDispatch} from '@/hooks';

interface DownloadPanelHeaderProps {
  id: string;
  isOpenedInModal?: boolean;
  isOpenedInPrintShop?: boolean;
  isViewingDropboxDownloads?: boolean;
  currentViewingOrderIdKey?: string;
  currentViewingOrder?: OrderDownloadStateNew;
  onClose(): void;
}

export function DownloadPanelHeader({
  isOpenedInPrintShop = false,
  isOpenedInModal = false,
  isViewingDropboxDownloads = false,
  currentViewingOrderIdKey = undefined,
  currentViewingOrder = undefined,
  ...props
}: DownloadPanelHeaderProps): ReactElement | undefined {
  const dispatch = useAppDispatch();

  const getPanelHeader = (): ReactElement | undefined => {
    if (!isOpenedInModal) {
      return undefined;
    }

    if (isOpenedInPrintShop && !isOpenedInModal) {
      return undefined;
    }

    if (isOpenedInPrintShop && isOpenedInModal) {
      if (!currentViewingOrderIdKey && !isViewingDropboxDownloads) {
        return undefined;
      }
    }

    let text = window.i18next.t('pmwjs_download');
    let showBackButton = false;

    if (isViewingDropboxDownloads) {
      text = window.i18next.t('pmwjs_save_to_dropbox');
      showBackButton = true;
    } else if (currentViewingOrderIdKey && currentViewingOrder) {
      if (currentViewingOrder.state === DownloadStateTypes.DOWNLOADING) {
        text = window.i18next.t('pmwjs_downloading');
        showBackButton = true;
      } else if (currentViewingOrder.state === DownloadStateTypes.READY) {
        showBackButton = true;
        text = window.i18next.t('pmwjs_enjoy_the_download');
      } else {
        showBackButton = true;
      }
    }

    return (
      <PanelHeader
        isOpenedInModal={isOpenedInModal}
        onBackButton={(): void => {
          if (isViewingDropboxDownloads) {
            dispatch(setIsViewingDropboxDownloads(false));
          } else if (currentViewingOrderIdKey) {
            dispatch(setCurrentViewingOrderIdKey(undefined));
          }
        }}
        showBackButton={showBackButton}
        onClose={(): void => {
          props.onClose();
        }}
        centerAlignTitle
        title={text}
      />
    );
  };

  return getPanelHeader();
}
